import axios from './axios';

export const getDriversByCarrierId = carrierId =>
  axios.get(`/transportation/carriers/${carrierId}/drivers`);

export const createDriver = (carrierId, supervisor, driver) =>
  axios.post('/transportation/users', {
    busCompanyId: carrierId,
    supervisor,
    ...driver,
  });

export const updateDriver = (carrierId, driverId, supervisor, driver) =>
  axios.put(`/transportation/users/${driverId}`, {
    busCompanyId: carrierId,
    supervisor,
    ...driver,
  });

export const removeDriver = driverId => axios.delete(`/transportation/drivers/${driverId}`);
